import { createMuiTheme } from "@material-ui/core";

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#5F4B8BFF",
    },
    secondary: {
      main: "#E69A8DFF",
    },
  },
  typography: {
    fontFamily: "'Overpass', sans-serif",
  },
});
